import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../context/AppContext';
import { loginUserAPI } from '../services/api';

const LoginPage = () => {
  const { setUser } = useContext(AppContext);
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !name) {
      alert('Please enter name and email.');
      return;
    }
    setLoading(true);
    try {
      const user = await loginUserAPI(name, email);
      setUser(user);
      localStorage.setItem('liveclass_user', JSON.stringify(user));
      navigate('/dashboard');
    } catch (err) {
      console.error(err);
      alert('Login error: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="row justify-content-center mt-5">
      <div className="col-md-5">
        <div className="card">
          <div className="card-header text-center">
            <h5>Live Class Pro Login</h5>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Name</label>
                <input
                  className="form-control"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Your name"
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                />
              </div>
              <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                {loading ? 'Logging in...' : 'Enter Dashboard'}
              </button>
            </form>
          </div>
          <div className="card-footer text-muted small text-center">
            PHP + MySQL backend handles simple user login / registration.
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
